import { render, staticRenderFns } from "./Herd.vue?vue&type=template&id=20c7f4bf&"
import script from "./Herd.vue?vue&type=script&lang=js&"
export * from "./Herd.vue?vue&type=script&lang=js&"
import style0 from "./Herd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports